// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logos/bripplex/fulllogo_transparent.png";

const date = new Date().getFullYear();

// Footer config — consumed by both the legacy DefaultFooter and the new
// SiteFooter. Menu IA reworked to lead with Product / Researchers, then
// Resources, then Legal — matching the 2026 redesign positioning.
export default {
  brand: {
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/bripplex",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/bripplex",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/bripplex",
    },
  ],
  menus: [
    {
      name: "Product",
      items: [
        { name: "How it works", href: "/#how-it-works" },
        { name: "Achievements", href: "/#achievements" },
        { name: "Download app", href: "/#download" },
      ],
    },
    {
      name: "Researchers",
      items: [
        { name: "For researchers", route: "/researchers" },
        { name: "Use cases", route: "/use-cases" },
        { name: "Contact sales", route: "/contact-sales" },
      ],
    },
    {
      name: "Resources",
      items: [
        { name: "What data we collect", href: "/docs/what" },
        { name: "How we collect data", href: "/docs/how" },
        { name: "Support", href: "mailto:support@bripplex.com" },
      ],
    },
    {
      name: "Legal",
      items: [
        { name: "Terms & conditions", href: "/docs/appTerms" },
        { name: "Privacy policy", href: "/dataPrivacy" },
        { name: "EULA", href: "/docs/EULA" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}{" "}
      <MKTypography
        component="a"
        href="https://halyardtech.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Halyard LLC
      </MKTypography>
      .
    </MKTypography>
  ),
};
